<template>
    <YearPickerCell
        :class="cn('border-none p-0 text-center text-content-sm focus-within:relative focus-within:z-20', props.class)"
        v-bind="forwardedProps"
    >
        <slot />
    </YearPickerCell>
</template>

<script setup lang="ts">
import { cn } from '@/lib/utils';
import { reactiveOmit } from '@vueuse/core';
import type { YearPickerCellProps } from 'reka-ui';
import { YearPickerCell, useForwardProps } from 'reka-ui';
import type { HTMLAttributes } from 'vue';

const props = defineProps<YearPickerCellProps & { class?: HTMLAttributes['class'] }>();

const delegatedProps = reactiveOmit(props, 'class');

const forwardedProps = useForwardProps(delegatedProps);
</script>
